/**
 * 自定义指令-禁止拖动
 * @author: BYM<yongming.bai@outlook.com>
 * v-no-drag  禁止拖动
 * v-no-drag.select 禁止拖动+禁止选中
 * v-no-drag.contextmenu 禁止拖动+禁止右击
 */
export default {
  inserted(el, binding) {
    // 默认禁用拖拽
    el.setAttribute('draggable', 'false');

    // 创建监听函数
    const preventDrag = e => e.preventDefault();
    el.__noDragListeners = { preventDrag };
    el.addEventListener('dragstart', preventDrag);

    // 可选拓展：禁止右键菜单
    if (binding.modifiers.contextmenu) {
      const preventContextMenu = e => e.preventDefault();
      el.addEventListener('contextmenu', preventContextMenu);
      el.__noDragListeners.preventContextMenu = preventContextMenu;
    }

    // 可选拓展：禁止选中
    if (binding.modifiers.select) {
      const preventSelect = e => e.preventDefault();
      el.addEventListener('selectstart', preventSelect); // 文字选中
      el.__noDragListeners.preventSelect = preventSelect;
      el.style.userSelect = 'none'; // 添加内联样式兜底（兼容性更好）
    }
  },
  unbind(el) {
    const {
      preventDrag,
      preventContextMenu,
      preventSelect
    } = el.__noDragListeners || {};

    preventDrag && el.removeEventListener('dragstart', preventDrag);
    preventContextMenu && el.removeEventListener('contextmenu', preventContextMenu);
    preventSelect && el.removeEventListener('selectstart', preventSelect);

    delete el.__noDragListeners;
  }
}
